import { render, staticRenderFns } from "./VideoTrim.vue?vue&type=template&id=c0a0f61e&scoped=true&"
import script from "./VideoTrim.vue?vue&type=script&setup=true&lang=ts&"
export * from "./VideoTrim.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./VideoTrim.vue?vue&type=style&index=0&id=c0a0f61e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0a0f61e",
  null
  
)

export default component.exports